import { Box, Button, Dialog, Flex, Text } from '@radix-ui/themes';
import { observer } from 'mobx-react-lite';
import { ContactSupportIcon, ErrorOutlineIcon } from 'shared/icons';

const JobCreateConfirmDialogView = ({
   loading,
   onConfirm,
}: {
   onConfirm: () => void;
   loading: boolean;
}) => {
   return (
      <Box className="deactivated-dialog">
         <Flex justify="center">
            <Text color="red">
               <ContactSupportIcon width={80} height={80} />
            </Text>
         </Flex>

         <Flex justify="center" direction="column" align="center" mt="5" mb="6">
            <Dialog.Title aria-describedby={undefined}>
               <Text size="7">Створити вакансію?</Text>
            </Dialog.Title>
            <Text size="5"> Ви хочете створити цю вакансію?</Text>
         </Flex>

         <Flex justify="center" gap="3">
            <Button color="red" size="3" loading={loading} onClick={onConfirm}>
               Підтведити
            </Button>

            <Dialog.Close>
               <Button color="gray" size="3">
                  Відмінити
               </Button>
            </Dialog.Close>
         </Flex>
      </Box>
   );
};

export const JobCreateConfirmDialog = observer(JobCreateConfirmDialogView);
